@if (!(search && search.searchCriteria)) {
    <ws-ace-loader [hasOverlay]="false"></ws-ace-loader>
}
@if (search) {
    <div>
        <div class="page-header as-header">
            @if (showPageTitle) {
                <h1 class="as-title">
                    <span>S<small>earch</small></span>
                    <span>M<small>ining</small></span>
                    <span>A<small>nd</small></span>
                    <span>R<small>eporting</small></span>
                    <span>T<small>ool</small></span>
                </h1>
            }
            @if (!showPageTitle) {
                <h1 class="as-title">{{ search.searchName }}</h1>
            }
            <div class="as-header-functions">
                @if (!isShown) {
                    <div helpTooltip helpContentId="smartSearch.show-criteria">
                        <button class="ace-btn has-icon btn-text icon-dark mb-0" (click)="showCriteria()">
                            <i class="fa fa-arrow-left fa-lg"></i>
                        </button>
                    </div>
                }
                @if (isSavedSearch && isSystemSearch) {
                    <div class="favorite">
                        @if (!search.isFavorite) {
                            <i class="fa fa-star-o favorite-star" (click)="favoriteSearchToggle(true)"></i>
                        }
                        @if (search.isFavorite) {
                            <i class="fa fa-star favorite-star" (click)="favoriteSearchToggle(false)"></i>
                        }
                    </div>
                }
                <div helpTooltip helpContentId="smartSearch.stop-sharing">
                    @if (!hideRevokeShareButton) {
                        <button class="ace-btn has-icon btn-text icon-dark mb-0" (click)="revokeSearchShare()">
                            <i class="fa fa-share-alt fa-lg" aria-hidden="true"></i>
                        </button>
                    }
                </div>
                @if (!isShown) {
                    <div helpTooltip helpContentId="app.refresh">
                        <button class="ace-btn has-icon btn-text icon-dark mb-0" (click)="reloadSearch()">
                            <i class="fa fa-refresh fa-lg"></i>
                        </button>
                    </div>
                }
                @if (isShown) {
                    <div helpTooltip helpContentId="smartSearch.clear-criteria">
                        <button class="ace-btn has-icon btn-text icon-dark mb-0" (click)="clearCriteria()">
                            <i class="fa fa-eraser fa-lg"></i>
                        </button>
                    </div>
                }
                <div helpTooltip helpContentId="app.save">
                    @if (!hideSaveButton) {
                        <button
                            class="ace-btn has-icon btn-text icon-dark mb-0"
                            (click)="saveSearch()"
                            [disabled]="!isSaveEnabled || !search.searchCriteria?.outputColumns.length">
                            <i class="fa fa-save fa-lg"></i>
                        </button>
                    }
                </div>
                <div helpTooltip
                     [helpContentId]="isSingleInstanceSelected ? 'app.save-as' : 'smartSearch.all-instances-selected'">
                    <button class="ace-btn has-icon btn-text icon-dark mb-0 ws-vertical-align-middle"
                            (click)="saveSearchAs()"
                            [disabled]="!search.searchCriteria?.outputColumns.length || !isSingleInstanceSelected">
                        <ws-save-as-icon class="w-100"></ws-save-as-icon>
                    </button>
                </div>
            </div>
        </div>
        @if (invalidColumns.length) {
            <div class="alert-danger">
                The following output columns are now invalid; please remove the disputing output columns to proceed
                <ul>
                    @for (column of invalidColumns; track column) {
                        <li>
                            <strong>{{ column.colName }}</strong> because of: @for (
                            offendingColumn of column.offendingColumns; track offendingColumn) {
                            <span class="label label-default" style="margin-left: 5px;"
                            >{{ offendingColumn }}</span>
                        }
                        </li>
                    }
                </ul>
            </div>
        }
        @if (isShown && search.searchCriteria) {
            <div class="row advanced-criteria">
                <div class="col-lg-8 ws-stretch-height">
                    <advanced-filter-list [searchCriteria]="search.searchCriteria"
                                          [routeParams]="routeParams"
                                          (filtersChanged)="userChangedSettings()">
                    </advanced-filter-list>
                </div>
                <div class="col-lg-4 ws-stretch-height">
                    <advanced-output-list [searchCriteria]="search.searchCriteria"
                                          [invalidColumns]="invalidColumns"
                                          (outputChanged)="userChangedSettings()">
                    </advanced-output-list>
                </div>
            </div>
        }
    </div>
}

